'use strict';

var util = require('./util');

/**
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormatObj
 * @return {object} - An object containing the price, currency symbol, abbreviation and a negative sign
 */
module.exports = function intelligentFormatObj(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormatObj(amount, options);
};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-contact-modal/~/dibs-currency-helpers/intelligentFormatObj.js
// module id = 2787
// module chunks = 64